import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Row, Col } from 'react-bootstrap';

import {
  InputField,
  CheckboxField,
  SelectField,
  required,
  number,
  url,
  TooltipLabel,
} from '../../../form';

class FeedCredentials extends Component {
  render() {
    const { feedFormType, isAuthUrl, hasSecureShell } = this.props;

    return (
      <div>
        <Field
          type='text'
          name='feed_type'
          label='Feed Type'
          validate={[required]}
          component={SelectField}
          options={[
            { label: 'HTTP', value: 'http' },
            { label: 'HTTP-AUTH', value: 'http_auth' },
            { label: 'FTP', value: 'ftp' },
            { label: 'SFTP', value: 'sftp' }
          ]}
          normalize={field => (field ? field.value : field)}
        />
        {
          (
            ['http', 'http_auth'].includes(feedFormType) &&
            (
              <div>
                <Field
                  type='text'
                  name='credentials[http][url]'
                  label='URL'
                  validate={[required, url]}
                  component={InputField}
                />
              </div>
            )
          )
        }
        {
          (
            feedFormType === 'http_auth' &&
            (
              <div>
                <Field
                  type='text'
                  name='credentials[http][username]'
                  label='Username'
                  validate={isAuthUrl ? [required] : []}
                  component={InputField}
                />
                <Field
                  type='password'
                  name='credentials[http][password]'
                  label='Password'
                  component={InputField}
                />
              </div>
            )
          )
        }
        {
          (
            ['ftp', 'sftp'].includes(feedFormType) &&
            (
              <div>
                { 
                  feedFormType === 'sftp' &&
                  (
                    <Field
                      type='checkbox'
                      name='credentials[ftp][ssh_login]'
                      label='SSH Login'
                      singleLine
                      component={CheckboxField}
                    />
                  )
                }
                <Row>
                  <Col md={6}>
                    <Field
                      type='text'
                      name='credentials[ftp][host]'
                      label='Host'
                      validate={[required]}
                      component={InputField}
                      className='col-md-6'
                    />
                  </Col>
                  <Col md={6}>
                    <Field
                      type='number'
                      name='credentials[ftp][port]'
                      label='Port'
                      validate={[required, number]}
                      parse={value => parseInt(value, 10)}
                      component={InputField}
                    />
                  </Col>
                </Row>
                <Field
                  type='text'
                  name='credentials[ftp][username]'
                  label='FTP Username'
                  validate={[required]}
                  component={InputField}
                />
                <Field
                  type='password'
                  name='credentials[ftp][password]'
                  label='FTP Password'
                  autoComplete={false}
                  validate={hasSecureShell && feedFormType === 'sftp' ? [] : [required]}
                  component={InputField}
                />
                <Field
                  type='text'
                  name='credentials[ftp][path]'
                  label='Path'
                  validate={[required]}
                  component={InputField}
                />
                <Row>
                  <Col md={6}>
                    <Field
                      type='text'
                      name='credentials[ftp][filename]'
                      label='File Name'
                      validate={[required]}
                      component={InputField}
                    />
                  </Col>
                  <Col md={6}>
                    <Field
                      type='text'
                      name='credentials[ftp][extension]'
                      label='Extension'
                      validate={[required]}
                      component={InputField}
                    />
                  </Col>
                </Row>
                
                <Field
                  type='checkbox'
                  name='credentials[ftp][list]'
                  label={
                    <TooltipLabel tooltipId='cron' labelText='List'>
                      If you version feed files instead of updating a single one, check this box so we know to take the most recent.  
                      Be sure to include the filename prefix in the input above.
                    </TooltipLabel>
                  }
                  singleLine
                  component={CheckboxField}
                />
              </div>
            )
          )
        }
        <Field
          type='checkbox'
          name='gzip'
          label='GZip'
          singleLine
          component={CheckboxField}
        />
      </div>           
    );
  }
}

export default (FeedCredentials);
